import { useMemo } from "react"
import { DataTable, Number } from "../../common"

const FeatureChargesTable = ({
  tableData,
  onChange = () => {},
  selectedRowKeys,
  checkBoxProps,
  columns,
  disabled,
  tableClass = false,
  showRowObject = true,
  yScroll = 240,
}) => {
  const modifiedTableData = useMemo(() => {
    return !tableData
      ? []
      : tableData.map(item => ({
          ...item,
          Amount: item?.numberComponentRequired ? (
            <Number
              value={item?.amount}
              isCurrency={!(item?.amountType === "percentile")}
              wrapValue={val => (item?.amountType === "percentile" ? `${val} %` : val)}
              className="gray-900"
            />
          ) : (
            item?.amount
          ),
        }))
  }, [tableData])

  let rowSelectionObject = {
    type: "checkbox",
    columnWidth: 20,
    onChange: onChange,
    selectedRowKeys: selectedRowKeys || [],
    getCheckboxProps: record => {
      return {
        disabled: disabled || record?.fixed,
        value: record?.fixed,
        ...checkBoxProps,
      }
    },
  }

  return (
    <DataTable
      tableLayout="auto"
      stickyOffset={-100}
      data={modifiedTableData}
      columns={columns || []}
      rowSelection={showRowObject ? rowSelectionObject : null}
      scroll={{
        y: yScroll,
      }}
      tableClass={tableClass || undefined}
    />
  )
}

export default FeatureChargesTable
